import { TextValue } from '@shared/types';

export const tablePageSizeOptions: number[] = [15, 25, 50, 100];
export const statusDefaultTextValue: TextValue = { text: 'status.all', value: -1 };
